import * as React from "react";
import useField, { useFieldProps } from "./useField";
import useApi, { API } from "../useApi";
import { KeyLabel, APIResponseType } from "src/Library/Types";
import { useSelect, useStaticSelect } from "./useSelect";

export const useRadio = <A, B, C>(
  props: useFieldProps<A>,
  api: API<B, C>,
  mapKeyLabel: (param?: C) => KeyLabel[],
  mapSearchArg: (queryString: string) => B,
) => {
  const field = useSelect(props, api, mapKeyLabel, mapSearchArg);

  const decorator = (child: React.ReactElement): React.ReactNode => {
    return field.decorator(
      React.cloneElement(child, {
        options: field.options.map(opt => ({ label: opt.label, value: opt.key })),
      })
    );
  };

  return {
    ...field,
    decorator,
    fieldType: 'radio',
  };
};

export const useStaticRadio = <OptionsDataType, T>(
  props: useFieldProps<T> & { defaultOptions?: KeyLabel[] },
) => {
  const field = useStaticSelect<OptionsDataType, T>(props);

  const decorator = (child: React.ReactElement): React.ReactNode => {
    return field.decorator(
      React.cloneElement(child, {
        ...child.props,
        options: field.options.map(opt => ({ label: opt.label, value: opt.key })),
      })
    );
  };

  return {
    ...field,
    decorator,
    fieldType: 'radio',
  };
};
